package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_04_14_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("When we last left our heroes, they had been ambushed by a group of orcs. The orcs had a giant fighting by their side, and an orc warchief had appeared in the distance.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes manage to repel the ambush, killing several orcs and the giant. They were able to capture the warchief, who they interrogated.  Our heroes were interested in how the orcs had integrated a giant into their raiding party.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Responses from the captive:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("“[The Giants] are running out of mountains.”")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("“They know Human bad, orc good.”")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("“Something scare them [Giantkin] out of mountain.”")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Something has taken “roost” in the hills.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Goram and Annette want to turn in the warlord to the authorities in Dorb, but Caper talks them out of it.  Our heroes allow the captive to leave with his life after he pledges to abandon his life of crime.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes resume the journey to Dorb.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Dorb may be the biggest town in the region, but before our heroes see the towns people, farms, or any buildings, they first see the foothills appear in the distance. Dorb is the Malusian empire’s southern military outpost and is situated on the edge of the hills that characterize the Malus region.  The town is not walled. The government owns and operates mines in Dorb.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Goram knows the dwarf who runs the inn. Our heroes rent a large room.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Goram also knows Jared the half-orc shopkeeper of the Gremlin’s Pouch. Goram purchases a sword, and Falorn purchases two diamonds.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes have had quite a day, and enjoy a good night’s rest. They have business in Dorb to meet Sir Sorlon Dragstone (a high level officer in the Malusian Calvary) and Sir Lorn Fogarth of the Peers. But that business can be conducted tomorrow.")
    }
}
